const isNativeCapacitorRuntime = Boolean(
  typeof window !== 'undefined'
  && window.Capacitor
  && (
    window.Capacitor?.isNativePlatform?.()
    || ['ios', 'android'].includes(String(window.Capacitor?.getPlatform?.() || '').toLowerCase())
  )
);

// Bundled native builds run from capacitor://localhost / http://localhost, so
// window.location.origin is not the API host. Keep browser/desktop behavior
// unchanged and give the native test shell an explicit online source of truth.
export const apiURL =
  process.env.REACT_APP_API_URL ||
  (isNativeCapacitorRuntime
    ? 'https://test.flclogin.com'
    : window.location.origin.replace('5050', '3000'));

// FS Bucket
export const filesURL = process.env.REACT_APP_FILE_BUCKET;
export const imagesURL = `${filesURL}/Images`;
export const audioURL = `${filesURL}/Audio`;

// Uploads Bucket
export const uploadsURL = process.env.REACT_APP_UPLOADS_BUCKET;

export const publicKey = 'public';
export const activitiesKey = `${publicKey}/Activities`;
export const usersKey = `${publicKey}/Users`;

export const s3bucketPublicURL = `${uploadsURL}/${publicKey}`;
export const activitiesURL = `${uploadsURL}/${activitiesKey}`;

export const stripePublicKey = process.env.REACT_APP_STRIPE_PUBLIC_KEY;